/**
 * We are using axios as our api layer. Each api should return the axios Promise,
 * then within the specific redux action, use the then() methods to
 * dispatch() the specific action for the UI to handle.
 * https://github.com/axios/axios
 * */
import axios from 'axios';

import { ATTACHMENT_DOWNLOAD } from "../constants/ApiEndpoints";


export default class AttachmentsApi {
    static getAttachment = (attachmentId) =>
        axios({
            method: 'get',
            url: `${ATTACHMENT_DOWNLOAD}/${attachmentId}`,
            responseType: 'arraybuffer'
        });
}